import { useEffect, useState } from "react";
import {
  TUpdateAttributePayload,
  useSocketClient,
} from "../contexts/SocketClientProvider";
import { IControlBase } from "../features/controls/types";

export default function useControlAttribute(
  control: IControlBase,
  attribute: string,
  initialValue?: any,
) {
  const [value, setValue] = useState(
    initialValue || control.attributes[attribute],
  );
  const socketClient = useSocketClient();
  useEffect(() => {
    const callback = (payload: TUpdateAttributePayload) => {
      if (payload.type === "control" && payload.id === control.id) {
        if (payload.attribute === attribute) {
          setValue(payload.value);
        }
      }
    };
    socketClient.subscribe(callback, "update_attribute");
    return () => socketClient.unsubscribe(callback, "update_attribute");
  }, [control, attribute, socketClient]);

  return value;
}
